<template>
	<div class="about-box">
		<el-timeline>
			<el-timeline-item timestamp="2019/12" placement="top">
				<el-card>
					<h4>搭建</h4>
					<p>注册域名</p>
					<p>GitHub托管</p>
				</el-card>
			</el-timeline-item>
			<el-timeline-item timestamp="2020/3" placement="top">
				<el-card>
					<h4>更新</h4>
					<p>多页面跳转</p>
					<p>增加了多媒体, 样式和动作
						<el-popover placement="top" trigger="hover" width="200">
							<p class="popover-title">图片压缩</p>
							<p class="popover-content">1.PS打开图片</p>
							<p class="popover-content">2.文件</p>
							<p class="popover-content">3.导出</p>
							<p class="popover-content">4.存储为Web所用格式</p>
							<sub>快捷键 Alt+Shift+Ctrl+S</sub>
							<i slot="reference" class="el-icon-paperclip"></i>
						</el-popover>
					</p>
				</el-card>
			</el-timeline-item>
			<el-timeline-item timestamp="2020/11" placement="top">
				<el-card>
					<h4>更新</h4>
					<p>记录搭建过程
						<i @click="$router.push({name:'Build'})" class="el-icon-paperclip"></i>
					</p>
					<p>加入了JQuery动画</p>
				</el-card>
			</el-timeline-item>
			<el-timeline-item timestamp="2021/5" placement="top">
				<el-card>
					<h4>更新</h4>
					<p>更新主页</p>
					<p>增加404页面</p>
				</el-card>
			</el-timeline-item>
			<el-timeline-item timestamp="2021/11" placement="top">
				<el-card>
					<h4>重新构建</h4>
					<p>使用Vue框架
						<el-popover placement="top" trigger="hover" width="200">
							<p class="popover-title">history路由模式</p>
							<p class="popover-content">1.进入GitHub仓库根目录</p>
							<p class="popover-content">2.新建404.html文件</p>
							<p class="popover-content">3.内容与index.html一致</p>
							<sub>解决刷新页面404的问题</sub>
							<i slot="reference" class="el-icon-paperclip"></i>
						</el-popover>
					</p>
					<p>非根目录下部署Vue项目
						<el-popover placement="top" trigger="hover" width="200">
							<p class="popover-title">配置文件</p>
							<p class="popover-content">1.进入项目根目录</p>
							<p class="popover-content">2.修改vue.config.js文件</p>
							<p class="popover-content">3.内容如下: </p>
							<pre>    module.exports = {</pre>
							<pre>      publicPath: '/路径'</pre>
							<pre>    }</pre>
							<sub>文件不存在则新建文件</sub>
							<i slot="reference" class="el-icon-paperclip"></i>
						</el-popover>
					</p>
				</el-card>
			</el-timeline-item>
		</el-timeline>
		<div class='about-footer'>
			<b>站内链接：</b>&nbsp;&nbsp;
			<el-link type='primary' href="/skills">Skills</el-link>&nbsp;&nbsp;
			<el-link type='primary' href="/bigdata">BigData</el-link>&nbsp;&nbsp;
			<el-link type='primary' href="/visualization">Visualization</el-link>&nbsp;&nbsp;
			<br>
			<b>站外链接：</b>&nbsp;
			<el-link type='primary' href="https://github.com/imliny/imliny.github.io" target="_blank">GitHub</el-link>
			&nbsp;&nbsp;
			<el-link href="http://150.158.89.91/" target="_blank" disabled>Annotation</el-link>
			<br>
			<el-popover placement="top" trigger="hover">
				<img src="../assets/about/erweima.png" width="200" />
				<span class="site">www.liny.ml</span>
				<i slot="reference" class="icon al-erweima"></i>
			</el-popover>&nbsp;
			<h1>Copyright © lyl.</h1>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'About'
	}
</script>

<style>
	.about-box {
		width: 95%;
		padding: 30px 20px;
		margin: auto;
		min-height: 90%;
		border-radius: 5px;
		background-color: rgba(255, 255, 255, 0.9);
		animation: show 1.2s ease-in;
	}

	.about-box .el-card {
		background-color: rgba(255, 255, 255, 0.5);
	}

	.about-box p {
		text-indent: 0.7em;
	}

	.about-footer {
		text-align: center;
		padding: 10px 5px;
		border-radius: 10px;
		font-size: 14px;
		background-color: rgba(166, 166, 166, 0.9);
	}

	.about-footer h1 {
		display: inline-block;
		font-size: 8px;
	}

	.popover-title {
		font-weight: bold;
	}

	.popover-content {
		text-indent: 1.5em;
	}

	.site {
		display: block;
		text-align: center;
	}

	@media screen and (max-width: 700px) {
		.about-box {
			padding: 20px 5px 20px 15px;
		}

		.about-box .el-timeline {
			padding-left: 0;
		}
	}
</style>
